













import moment from 'moment';
import 'moment/locale/zh-hk';
import Vue from 'vue';

export default Vue.extend({
  mounted() {
    moment.locale('zh-hk');
  },
  props: {
    value: String,
    formatString: String,
    calendar: Boolean,
  },
  computed: {
    momentValue(): moment.Moment {
      return moment(this.$props.value);
    },
    formattedValue(): string {
      let formatString = this.$props.formatString;

      if (this.$props.formatString === undefined ||
          this.$props.formatString === null ||
          this.$props.formatString === '') {
        formatString = 'YYYY-MM-DD HH:mm:ss';
      }

      return moment(this.$props.value).format(formatString);
    },
  },
});
